import { of } from "rxjs";
import { IAppTranslations } from "lib/translations/interfaces/translations.interface";

export class WelcomeBack {
    message: any;
    continue: any;
    title: any = {
        value: ''
    };
    constructor(translations: IAppTranslations) {
        this.message = translations.assessment_return_message;
        this.title = translations.assessment_welcome_back;
        this.continue = translations.common_continue;
    }

    build(): any {
        return of({
            title: this.title ? this.title : '',
            message: this.message ? this.message : '',
            size: 'md',
            buttons: {
                close: {
                    label: this.continue ? this.continue : '',
                    className: 'btn-primary mx-auto text-capitalize'
                }
            }
        });
    }
}
